export default __webpack_public_path__ + "static/media/hand-with-chocolate@2x.88ac16ca.png";